import React from 'react';
import { Link } from 'react-router-dom';

const Methodology = ({}) => (
  <div class="section is-medium">
      <div class="container">
          <div className="section-title-wrapper has-text-centered">
              <div className="special-divider">
                  <span></span>
                  <span></span>
              </div>
              <h2 className="title is-2">Basit ama Etkili bir Formülümüz var.</h2>
              <h4 className="subtitle is-4">Başarılı projelerin sırrını paylaşıyoruz.</h4>
          </div>
          <div class="columns is-vcentered">
              <div class="column is-7 has-text-centered">
                  <img class="featured-svg" src="assets/images/illustrations/drawings/landing5-1.svg" alt="" />
              </div>
              <div class="column is-5">
                  <h3 class="detailed-feature-subtitle">Hazırlık</h3>
                  <h2 class="title is-3 no-margin">İhtiyacınızı Tespit Edin</h2>
                  <div class="title-divider"></div>
                  
              </div>
          </div>
          <div class="columns is-vcentered">
              <div class="column is-7 has-text-centered is-hidden-tablet is-hidden-desktop">
                  <img class="featured-svg" src="assets/images/illustrations/drawings/landing5-3.svg" alt="" />
              </div>
              <div class="column is-5 has-text-right">
                  <h3 class="detailed-feature-subtitle">Donanımlı Ekip</h3>
                  <h2 class="title is-3 no-margin">Doğru Kişiler ile Çalışın</h2>
                  <div class="title-divider is-right"></div>

              </div>
              <div class="column is-7 has-text-centered is-hidden-mobile">
                  <img class="featured-svg" src="assets/images/illustrations/drawings/landing5-3.svg" alt="" />
              </div>
          </div>
          <div class="columns is-vcentered">
              <div class="column is-7 has-text-centered">
                  <img class="featured-svg" src="assets/images/illustrations/drawings/landing5-4.svg" alt="" />
              </div>
              <div class="column is-5">
                  <h3 class="detailed-feature-subtitle">Doğru Yazılım</h3>
                  <h2 class="title is-3 no-margin">Yazılım Seçiminde Bilinçli Olun</h2>
                  <div class="title-divider"></div>

              </div>
          </div>
          <div className="cta-wrapper has-text-centered is-title-reveal">
              <h4 className="subtitle is-4">Başarıda <span style={{ color: '#6EBDFF', fontWeight: '700' }}>BÜTÜN</span>lüğü yakalamak için</h4>
              <a href="#contact" className="button button-cta is-bold btn-align primary-btn raised">
                  Bize Ulaşın
              </a>
          </div>
      </div>
  </div>
);

export default Methodology;
